<template>
    <v-row v-if="agreement" no-gutters justify="space-between" align="center">
        <v-col cols="auto" class="d-flex align-center">
            <v-icon size="18" class="mr-1">mdi-repeat</v-icon>
            {{ agreement.ReoccuranceRepeat }} {{ agreement.ReoccuranceHowOften }}
        </v-col>
        <v-col cols="auto" class="d-flex align-center px-4">
            <v-icon size="18" class="mr-1">mdi-timer</v-icon>
            {{ agreement.HoursOfWorkEachTechnician }} {{
                $t('servicesystem.common_objects.service_agreement.hours') }}
        </v-col>
        <v-col cols="auto" class="d-flex align-center">
            <v-icon size="20" class="mr-1">$technician</v-icon>
            x {{ agreement.NumberOfTechnicianRequired }}
        </v-col>
    </v-row>
</template>


<script>
export default {
    name: 'ServiceAgreementReocurrenceBar',
    props: {
        agreement: Object,
    },
    components: {},

    data() {
        return {};
    },

    methods: {},

    computed: {},

    watch: {},
};
</script>


<style lang='scss' scoped></style>